export default __webpack_public_path__ + "static/media/Report_Que.0f1bf929.svg";